import React from 'react'
import type { IntlShape } from 'react-intl'
import LineMoneyBillSlashIcon from 'LuxKit/Icons/line/LineMoneyBillSlashIcon'
import LineSmileIcon from 'LuxKit/Icons/line/LineSmileIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import { formatRoundedAmountWithDollarType } from 'lib/format/formatCurrencyIntl'
import { getHoolahBpMaxLimit } from 'lib/payment/hoolahBpUtils'

export function getStepsHowItWorks(intl: IntlShape) {
  return [
    {
      image: <LineCalendarIcon size="XL" />,
      title: intl.formatMessage({
        id: 'V5s4YsIDBa',
        defaultMessage: 'Pay in three instalments.',
        description: 'Step 1 title for How it works section on Shopback landing page',
      }),
      description: intl.formatMessage({
        id: '4cSQ1FAbeP',
        defaultMessage: 'Pay your first instalment at the time of purchase and the rest in 2 equal monthly instalments.',
        description: 'Step 1 description for How it works section on Shopback landing page',
      }),
    },
    {
      image: <LineMoneyBillSlashIcon size="XL" />,
      title: intl.formatMessage({
        id: 'mu3T69J2Td',
        defaultMessage: 'No hidden fees. You only pay what you see.',
        description: 'Step 2 title for How it works section on Shopback landing page',
      }),
      description: intl.formatMessage({
        id: 'dCvOpDSxM2',
        defaultMessage: 'The only fees are for late payments. But don\u2019t worry, Shopback will send you regular reminders.',
        description: 'Step 2 description for How it works section on Shopback landing page',
      }),
    },
    {
      image: <LineSmileIcon size="XL" />,
      title: intl.formatMessage({
        id: '/ocbhuKZDD',
        defaultMessage: 'No minimum spend.',
        description: 'Step 3 title for How it works section on Shopback landing page',
      }),
      description: intl.formatMessage({
        id: 'XFphaMo2lK',
        defaultMessage: 'Get what you need, when you need it, without any minimum spend.',
        description: 'Step 3 description for How it works section on Shopback landing page',
      }),
    },
  ]
}

export function getStepsBuyNow(intl: IntlShape, currency: string, regionCode: string) {
  return [
    {
      title: '1',
      description: intl.formatMessage({
        id: 'OfFqUhE+4v',
        defaultMessage: 'Browse your favourite escapes.',
        description: 'Step 1 description for Buy now section on Shopback landing page',
      }),
    },
    {
      title: '2',
      description: intl.formatMessage(
        {
          id: 'VgbYKymASe',
          defaultMessage: 'Choose Shopback as your payment method for purchases {maxLimit} and under',
          description: 'Step 2 description for Buy now section on Shopback landing page with max purchase limit',
        },
        {
          maxLimit: formatRoundedAmountWithDollarType(getHoolahBpMaxLimit(currency), currency, regionCode),
        },
      ),
    },
    {
      title: '3',
      description: intl.formatMessage({
        id: 'iPdjKcP4/y',
        defaultMessage: 'Instantly create an account or login and pay your first instalment when you checkout.',
        description: 'Step 3 description for Buy now section on Shopback landing page',
      }),
    },
  ]
}

const urls: Record<string, string> = {
  SGD: 'https://support.shopback.sg/hc/en-us/articles/4843519567891-ShopBack-PayLater-SBPL-Terms-of-Use',
  MYR: 'https://support.shopback.my/hc/en-us/articles/5171311855891-ShopBack-PayLater-SBPL-Terms-of-Use',
  HKD: 'https://www.hoolah.co/hk-en/terms/',
}
export function getTermsAndConditionsUrlLink(currency: string) {
  return urls[currency]
}
